import { CloudDownloadOutlined, PlusOutlined } from '@ant-design/icons'
import { GraviButton, Horizontal } from '@gravitate-js/excalibrr'
import api from '@utils/api'
import { Upload } from 'antd'
import { useState } from 'react'

type FooterProps = {
  canEditOrderMovements: boolean
  onCancel: () => void
  movementDetails: Gravitate.OrderMovementDetails | undefined
  onUploadImage: (file: File) => boolean | Promise<void>
  isImageUploading?: boolean
  hasImages: boolean
}

export function Footer({
  canEditOrderMovements,
  onCancel,
  movementDetails,
  onUploadImage,
  isImageUploading,
  hasImages,
}: FooterProps) {
  const [imagesDownloading, setImagesDownloading] = useState(false)
  async function downloadDropAttachmentImages() {
    try {
      setImagesDownloading(true)
      const resp = await api.getDropAttachmentsPDF(movementDetails?.order_number)
      const url = window.URL.createObjectURL(new Blob([resp.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `Order ${movementDetails?.order_number} Drop Attachments.pdf`)
      document.body.appendChild(link)
      link.click()
    } catch (error) {
      console.error('Error downloading drop attachment images:', error)
    } finally {
      setImagesDownloading(false)
    }
  }

  return (
    <div className='pt-3'>
      {canEditOrderMovements && (
        <Horizontal justifyContent='space-between' verticalCenter>
          <Upload accept='image/*,.pdf' beforeUpload={onUploadImage} showUploadList={false}>
            <GraviButton icon={<PlusOutlined />} buttonText='Add Attachment' loading={isImageUploading} />
          </Upload>
          <Horizontal className='p-3' justifyContent='flex-end'>
            <GraviButton buttonText='Close' onClick={() => onCancel()} className='mr-3' />
            <GraviButton
              disabled={!hasImages}
              icon={<CloudDownloadOutlined />}
              onClick={downloadDropAttachmentImages}
              loading={imagesDownloading}
              buttonText='Download'
              theme2
            />
          </Horizontal>
        </Horizontal>
      )}
    </div>
  )
}
